import React, { useEffect, useState } from "react";
import { LATEST_GALLERY } from "../utils/constants";
import PreviousIcon from "assets/breakfast-event/svgs/previous.svg";
import NextIcon from "assets/breakfast-event/svgs/next.svg";
import ActiveIcon from "assets/breakfast-event/svgs/active-page.svg";
import InActiveIcon from "assets/breakfast-event/svgs/inactive-page.svg";
import LineImage from "assets/breakfast-event/svgs/line-design.svg";
import PreviousIcon1 from "assets/breakfast-event/svgs/previous-1.svg";
import NextIcon1 from "assets/breakfast-event/svgs/next-1.svg";
import ActiveIcon1 from "assets/breakfast-event/svgs/active-page-1.svg";
import InActiveIcon1 from "assets/breakfast-event/svgs/inactive-page-1.svg";
import LineImage1 from "assets/breakfast-event/svgs/line-design-1.svg";

const CARD_WIDTH = 354; // same as your md width
const GAP = 20; // gap-5 = 20px
const VISIBLE = 4;

const Pagination = ({ containerRef, type }) => {
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil(LATEST_GALLERY.length / VISIBLE);

  const scrollToPage = (p) => {
    if (!containerRef.current) return;
    const scrollX = p * VISIBLE * (CARD_WIDTH + GAP);
    containerRef.current.scrollTo({ left: scrollX, behavior: "smooth" });
    setPage(p);
  };

  const next = () => page < totalPages - 1 && scrollToPage(page + 1);
  const prev = () => page > 0 && scrollToPage(page - 1);
  // Sync dots when user scrolls manually
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handler = () => {
      const index = Math.round(el.scrollLeft / (VISIBLE * (CARD_WIDTH + GAP)));
      setPage(index);
    };
    el.addEventListener("scroll", handler);
    return () => el.removeEventListener("scroll", handler);
  }, []);
  return (
    <div className="w-[92%] flex justify-center items-center gap-5">
      <div className="flex items-center justify-center gap-6">
        {/* Left Arrow */}
        <button
          onClick={prev}
          disabled={page === 0}
          className="border-none bg-transparent"
        >
          <img
            src={type === "faq" ? PreviousIcon : PreviousIcon1}
            alt="PreviousIcon"
          />
        </button>

        {/* Dots */}
        <div className="flex gap-2">
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              onClick={() => scrollToPage(i)}
              className="border-none bg-transparent"
            >
              {i === page ? (
                <img
                  src={type === "faq" ? ActiveIcon : ActiveIcon1}
                  alt="ActiveIcon"
                />
              ) : (
                <img
                  src={type === "faq" ? InActiveIcon : InActiveIcon1}
                  alt="InActiveIcon"
                />
              )}
            </button>
          ))}
        </div>

        {/* Right Arrow */}
        <button
          onClick={next}
          disabled={page === totalPages - 1}
          className="border-none bg-transparent"
        >
          <img src={type === "faq" ? NextIcon : NextIcon1} alt="NextIcon" />
        </button>
      </div>
      <img
        src={type === "faq" ? LineImage : LineImage1}
        alt="LineImage"
        className="hidden xl:block w-full"
      />
    </div>
  );
};

export default Pagination;
